module.exports = __webpack_public_path__ + "static/media/man.2225e910.png";